module.exports = __webpack_public_path__ + "img/record_off.8609b2da.svg";